import {Injectable} from '@angular/core';
import {Constant} from '../../global/util/Constant';
import {HttpClient} from '@angular/common/http';
import {Template} from '../model/Template';
import {Observable} from 'rxjs';
import {Headers} from '../../global/util/Headers';
import {Cell} from '../model/others/Cell';
import {Column} from '../model/others/Column';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  private url = Constant.ROOT_API_V1.concat('/templates');

  constructor(private http: HttpClient) {
  }

  public save(template: Template): Observable<any> {
    return this.http.post(this.url, JSON.stringify(template), Headers.contentType);
  }

  public get(url: string) {
    return this.http.get(url);
  }

  edit(template: Template): Observable<any> {
    return this.http.put(this.url, JSON.stringify(template), Headers.contentType);
  }

  getElementByDefault() {
    // const cells: Array<Cell> = [{cellName: 'Cell1'}];
    // const columns: Array<Column> = [{colName: 'Column1'}];
    // const rows: any[] = [{
    //   rowItem: 1,
    //   cells
    // }];
    return [{
      type: 1,
      text: 'Título por defecto',
      fontProperty: {},
      imageProperty: {},
      tableProperty: {},
      style: 'transform:translate3d(-8px, 20px, 0px);'
    }];
    // rows,
    // columns,
  }

  delete(templateId: number) {
    return this.http.delete(this.url.concat('?templateId=').concat(String(templateId)));
  }

  uploadTo(formData: FormData) {
    return this.http.post(this.url.concat('/upload'), formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  uploadToEdit(formData: FormData) {
    return this.http.post(this.url.concat('/upload/edit'), formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}
